<!-- next 차트, light 차트 제외 모든 알람 레이아웃 동일로 하나의 파일로 처리 / 데이터만 변경 -->
<template>
    <div 
    class="alarm_container"
    :class="[
        {'no_sub_container': subPath == 'support-resistance'},
        {'no_select_alarm': subPath == 'price'},
        {'premium': subPath == 'premium'}
    ]"
    >
        <div class="sub_category_cotainer" v-show="subTab?.length > 0">
            <div class="sub_category">
                <div 
                v-for="tab in subTab" :key="tab"
                @click="subChange(tab.type)" 
                :class="{
                    active: tab.type === selectedTab,
                    premium: tab.type.includes('premium') || tab.type === 'rsi',
                }"
                >
                    {{ tab.tab }}
                </div>
            </div>
        </div>
      

        <div 
        class="set_alarm_container" 
        :class="[
        { 'not_sub_category': subTab?.length > 0 },
        ]"
        v-if="noPermission()"
        >
            
            <SelectAlarm :alarmStatus="alarmStatus" :alarmList="alarmList" :routeName="routeName" @getChangedStatus="getAlarmStatus(routeName)"/>
        </div>

        <CoinList 
        v-if="subPath !='price' && userPackage"
        :historyList="historyList"
        :insightList="insightList"
        :type="type"
        :loadApi="loadApi"
        :userPackage="userPackage"
        @openGuide="guideOpen"
        />

        <AlarmModal v-if="openModal" @close="goAlarmHome" :type="openModal"/>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";

import { convertDateForm } from "@/utils/localeTime";
import { chkPermission } from "@/utils/permission.js";

import apiAlarm from "@/api/apiAlarm.js"
import CoinList from "@/components/alarm/common/CoinList"
import SelectAlarm from "@/components/alarm/common/SelectAlarm.vue";
import AlarmModal from '@/components/alarm/common/AlarmModal.vue'

const store = useStore();
const route = useRoute();
const router = useRouter();
const subPath = ref(route.path.split('/')[2])
const type = ref(route.query?.type)
const loadApi = ref(false);
const userPackage = ref(0);
const openModal = ref('');

const { t } = useI18n();

// 탭별 서브 카테고리 매치
const subTabList = ref({
    'price': [],
    'score': [
        { tab: '6.4', type: 'score' }, 
        { tab: t('guide.volume.title'), type: 'volatility' }
    ],
    'support-resistance': [],
    'premium':  [
        { tab: t('alarm.subTab.premium'), type: 'premium' }, 
        { tab: t('alarm.subTab.premiumPro'), type: 'premium-pro' },
        { tab: t('guide.rsi.title'), type: 'rsi' },
    ],
    'smart':  [
        { tab: t('alarm.subTab.smart'), type: 'smart' }, 
        { tab: t('alarm.subTab.smartPro'), type: 'smart-pro' }
    ],
    // 'real':  [
    //     { tab: t('real.title'), type: 'real' }, 
    //     { tab: t('rocket.title'), type: 'rocket' }
    // ]
    'rocket':  []
});

const subTab = ref(subTabList.value[subPath.value])

// 선택된 서브 카테고리
const selectedTab = ref(type.value ||  '')

// 서브 카테고리 변경 함수
async function subChange(query) {
    loadApi.value = false;
    selectedTab.value = query;
    type.value = query;

    await chgRoute(query);
    router.push({
        query: {
        ...route.query, 
        type: query,  
        },
    });

    loadApi.value = true;
}

// 알람 설정 & 검색 없애기
function noPermission() {
    if (subPath.value == 'price') { return false }
    else if (type.value === 'premium-pro' && !userProPermission.value) { return false }
    else if (subPath.value === 'smart' && !okSmart.value) { return false }

    return true;
}

// api 호출 주소 설정
const routeName = ref('');

async function chgRoute(tab) {
    if (subPath.value == 'price') { return }
    
    else if (subPath.value == 'score' || subPath.value == 'premium' && type.value == 'rsi' ) {
        routeName.value = (tab || type.value) + '-alarm';
    }
    else if (subPath.value == 'premium' && type.value !== 'rsi' || subPath.value == 'smart') {
        routeName.value = (tab || type.value) + '-chart-alarm';
    }
    else if (subPath.value == 'support-resistance') {
        routeName.value = 'sr-alarm'
    }
    else if (subPath.value == 'rocket') {
        routeName.value = 'rocket-alarm'
    }

    await getAlarmStatus(routeName.value);
    await setHistoryList(routeName.value)

    if (subPath.value == 'score') { 
        loadApi.value = true;
    }
}

// 유저 설정 알람 상태 가져오기
const alarmStatus = ref();

async function getAlarmStatus(routeName) {
    let status = await apiAlarm.getAlarms(routeName);
    alarmStatus.value = status.data
}


// 알람 리스트
const alarmList = ref([]);

async function setAlarmList() {
    let alarms = await apiAlarm.getAlarmSound();

    for (let i = 0; i < alarms.data.length; i++) {
        let alarm = alarms.data[i]
        if (alarm.filename == 'default') {
            alarmList.value.push(t('alarm.price.default'))
        }
        else (
            alarmList.value.push(t('alarm.price.soundFormat', {number: i}))
        )
    }

    // localStorage.setItem('alarmList', JSON.stringify(alarmList.value))
}

// history
const historyList = ref([]);

async function setHistoryList(routeName) {
    let histories;
    
    // let binanceList = await apiExc.getBinanceList();

    // if (routeName == 'sr-alarm') {
    //     let srList =  await apiAlarm.getHistory(routeName + '-histories');
    //     let rocketList =  await apiAlarm.getHistory('rocket-alarm-histories');

    //     for (let rocket of rocketList.data) {
    //         rocket.coin = 'BTC'
    //     }

    //     histories = [...(srList.data || []), ...(rocketList.data || [])];
    // }

    // console.log('routeName', routeName);

    if (routeName == 'rocket-alarm') {
        let historyData = await apiAlarm.getHistory(routeName + '-histories');

        for (let rocket of historyData.data) {
            rocket.coin = 'BTC'
        }

        histories = historyData.data
    }

    else {
        let historyData = await apiAlarm.getHistory(routeName + '-histories');
        histories = historyData.data
    }

    if (type.value != 'volatility') {
        histories = convertDateForm(histories)
    }

    // const validCoins = new Set(binanceList.tickers);
    // histories = histories.filter(history => validCoins.has(history.coin));

    histories.forEach(history => {
        if (history.exchange == "Binance") {
            history.excId = 1
        }
        else if (history.exchange  == "Bybit") {
            history.excId = 2
        }
        else if (history.exchange  == "OKX") {
            history.excId = 3
        }
    });

    historyList.value = histories;
}

// insight alarm coins
const insightList = ref([]);

async function getSelected() {
    if (subPath.value == 'score' || subPath.value == 'price') { return }

    if (subPath.value !== 'rocket') {
        let coins = await apiAlarm.getSeletedCoins();
        insightList.value = coins.data
    }

    loadApi.value = true;
}

const permission = ref(false);
const okSmart = ref(false);
const userProPermission = ref(0);

// 스마트 차트 결제여부 확인 함수 
async function chkSmartPlan() {
    const result = await chkPermission();
    permission.value = result.permission;
    userPackage.value = result.userPackage;
    okSmart.value = result.okSmart;
    userProPermission.value = result.okPro;

    if (subPath.value == 'smart' && !okSmart.value) {
        openModal.value = "smart"
    }

    if (!userPackage.value) {
        openModal.value = 'permission';
    }
}

const guideOpen = (type) => {
    openModal.value = type;
};

function goAlarmHome() {
    openModal.value = '';
    router.push('/alarm/dashboard');
}


// 로그인 처리 
const loginSuccessful = computed(() => {
    return store.state.loginStatus.loginSuccessful;
}) 

const loadSuccess = async() => {
    if (window.webkit?.messageHandlers?.loadHandler) {
        window.webkit.messageHandlers.loadHandler.postMessage('Load state changed.');
    }
    if (window.Android?.loadTriggered) {
        window.Android.loadTriggered();
    }

    await setAlarmList();
    await chkSmartPlan();
};


// Watchers
watch(loginSuccessful, async (newVal) => {
    if (newVal === true) {
        await chgRoute();
        await getSelected();
        await loadSuccess();
    }
});

watch(() => route.query.type, (newV) => {
    selectedTab.value = newV;
    chgRoute(newV);
})

onMounted(async () => {
    await chgRoute();
    await getSelected();
    await loadSuccess();
})
</script>

<style scoped>
.alarm_container.premium {
    padding-top: 150px;
}
</style>